import { useState } from 'react';
import { Api, apiRequest, notifyHttpError, notifySuccess, rethrowError } from 'api';
import Storage from 'services/storage.service';

const hubspot = {
    portal: '4268397',
    form: 'bef73e0b-bae2-48c4-af18-de424651a479',
};

/**
 * React hook to send a form at Hupspot
 */
function useHubspotForm({ analytics, t, onSuccess = () => {}, onError = () => {}, options = {} }: any) {
    const [loading, setLoading] = useState(false);
    const { successMessage } = options;

    const onSubmit = async (form: any) => {
        const { name, lastName, phone, email, schedule, privacy, newsletter, crosswordId, crosswordValid } = form;
        const { utms } = Storage.get({ key: Storage.keys.config }) || {};
        const params = {
            firstname: `${name}`,
            lastname: `${lastName}`,
            phone,
            email,
            acepta_comunicaciones: newsletter,
            suscripcion_newsletter: true,
            privacidad: privacy,
            lifecyclestage: 'subscriber',
            data_trigger: 'Form_send',
            ...(utms || {}),
            ...(analytics || {}),
            ...(crosswordId
                ? { sorteo_crucigramas: true, id_crucigrama: crosswordId, crucigrama_correcto: crosswordValid }
                : {}),
            horario_contacto: schedule,
        };

        setLoading(true);
        apiRequest(Api().hubspot.form({ ...hubspot, params }))
            .then((data: any) => {
                onSuccess(data);
                notifySuccess(
                    successMessage || {
                        title: t('subscribe.contact.success.title'),
                        message: t('subscribe.contact.success.message'),
                    }
                )();
            })
            .catch(error => {
                onError(error);
                rethrowError(notifyHttpError())(error);
            })
            .finally(setLoading(false));
    };

    return {
        loading,
        onSubmit,
    };
}

export default useHubspotForm;
